const Cart = () => {
  return (
    <div>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
      <h1>This is the cart</h1>
    </div>
  );
};

export default Cart;
